// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"genericButton_buttonWrapper__15uGE","button":"genericButton_button__Kcky8","text":"genericButton_text__80p-n"};